import { Component, OnInit, ViewChild, ElementRef, OnDestroy } from '@angular/core';
import { ThemeService } from 'src/app/services/theme.service';
import { UnidadeService } from 'src/app/services/http/unidade.service';
import { ConsultaService } from 'src/app/services/http/consulta.service';
import { PermissaoUsuario } from 'src/app/models/permissao-usuario';
import { Consulta } from 'src/app/models/consulta';
import { ModalMsgService } from 'src/app/services/modal-msg.service';
import { FormGroup, FormBuilder, Validators, FormControl, ValidationErrors } from '@angular/forms';
import { first, distinctUntilChanged, debounceTime, filter, debounce } from 'rxjs/operators';
import { UtilValidators } from 'src/app/utils/util-validators';
import { UtilMasks } from 'src/app/utils/util-masks';
import { UtilForms } from 'src/app/utils/util-forms';
import { MouseEvent } from '@agm/core';
import { EnderecoService } from 'src/app/services/http/endereco.service';
import { LoginService } from 'src/app/services/login.service';
import { ModalJustificativaComponent } from 'src/app/app-components/modal-justificativa/modal-justificativa.component';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Router, ActivatedRoute } from '@angular/router';
import { Unidade } from 'src/app/models/Unidade';
import { CiacService } from 'src/app/services/http/ciac.service';
import { environment } from 'src/environments/environment';
import * as moment from 'moment';
import { UserConfigsUtils } from 'src/app/utils/UserConfigsUtils';

@Component({
  selector: 'app-form-unidade',
  templateUrl: './form-unidade.component.html',
  styleUrls: ['./form-unidade.component.scss']
})
export class FormUnidadeComponent implements OnInit, OnDestroy {

  @ViewChild('imageInputFile', { static: false }) imageInputFile: ElementRef;
  masks = {
    cpf: { guide: false, mask: UtilMasks.cpf },
    telefone: { guide: false, mask: UtilMasks.telefone },
    cnpj: { guide: false, mask: UtilMasks.cnpj },
    data: { guide: false, mask: UtilMasks.dataBr },
    cep: { guide: false, mask: UtilMasks.cep },
    moeda: { guide: false, mask: UtilMasks.moeda },
  }
  id = null;
  login: any;
  colors = [];
  listaPermissaoUsuario: PermissaoUsuario[];
  listaConsultas: Consulta[];
  listaPrecoTipoLaudo = [];
  listaPrecoConsulta = [];
  listaUnidades: any = [];
  listaTipoUnidade = [];
  listaConsultaCredito = [];
  listaEstados = UtilForms.optionsEstado.nome;
  listaConsultasCombinadas: any;
  desativarInputsEBotoes: boolean = false;

  image: any;
  form: FormGroup;
  formEndereco: FormGroup;
  formUsuario: FormGroup;
  razaoSocial = new FormControl('');
  cnpj = new FormControl('');
  cpf = new FormControl('');

  exibirDocumentoConsultas: boolean;
  unidade = new Unidade([]);

  cliente: boolean = false;
  idCliente: any;
  idUsuario: any;
  consultas: any;
  campoEditavel: boolean = false;

  constructor(
    private activatedRoute: ActivatedRoute,
    private router: Router,
    private modalService: NgbModal,
    private loginService: LoginService,
    private enderecoService: EnderecoService,
    private fb: FormBuilder,
    private modalMsgService: ModalMsgService,
    private themeService: ThemeService,
    private unidadeService: UnidadeService,
    private consultaService: ConsultaService,
    private ciacService: CiacService,
    private utilValidators: UtilValidators) {

      try{
        if ( this.activatedRoute.snapshot.data['desativarInputsEBotoes'] === true ) {
            this.desativarInputsEBotoes = this.activatedRoute.snapshot.data['desativarInputsEBotoes'];
        }
      } catch (e) {
        console.log(e.stack);
      }

  }

  ngOnDestroy(): void {
    this.themeService.getTheme().pipe(first()).subscribe(r => this.unidade.cor = r);
  }

  async ngOnInit() {
    this.id = this.activatedRoute.snapshot.params.id || null;
    this.cliente = this.activatedRoute.snapshot.data.cliente || false;
    this.formInit();

    this.colors = this.themeService.getList();
    this.loginService.getLogIn().pipe(first()).subscribe(r => {
      this.login = r;
      let selected = { id: 0, nomeFantasia: 'Selecione', uuid: '' };
      if (r.unidade) {
        selected = { 
          id: r.unidade.id, 
          nomeFantasia: r.unidade.nomeFantasia,
          uuid: r.unidade.uuid
        };
        this.form.controls.unidadePai.patchValue(r.id);
      }
      if (this.listaUnidades.length == 0) {
        this.listaUnidades.push(selected);
      } else {
        this.listaUnidades.shift(selected);
      }
    });

    let idUnidade = parseInt(this.login.unidade.id);
    let idURL = this.activatedRoute.snapshot.params.id;
    this.campoEditavel = this.visualizarCamposEditaveis(idUnidade, idURL);

    if(this.id) {
      this.unidadeService.buscarUnidade(this.id).subscribe( c => {
        if(c['erro'] === true) {
          this.router.navigate(['error'])
        }
      });
    }

    if (this.id) {
      await this.unidadeService.getUnidade(this.id).then(r => {
        this.unidade = r.unidade;
        this.image = this.unidade.logo;
        this.unidade.cor = (this.unidade.cor.search('-theme') >= 0) ? this.unidade.cor : this.unidade.cor + '-theme';
        this.listaConsultas = this.unidade.listaConsultas;
        this.listaConsultaCredito = this.unidade.listaConsultasCredito;
        this.listaConsultasCombinadas = this.unidade.listaConsultasCombinadas;
          this.formEndereco.patchValue({
            cep: this.unidade.endereco.cep,
            cidade: this.unidade.endereco.cidade,
            estado: this.unidade.endereco.estado,
            bairro: this.unidade.endereco.bairro,
            numero: this.unidade.endereco.numero,
            rua: this.unidade.endereco.rua,
            complemento: this.unidade.endereco.complemento,
          }, {emitEvent: false});
        this.formUsuario.patchValue({
          nome: this.unidade.usuario.nome,
          email: this.unidade.usuario.email,
          emailConf: this.unidade.usuario.email,
          login: this.unidade.usuario.login,
          senha: this.unidade.usuario.senha,
          senhaConf: this.unidade.usuario.senha,
        });
        this.form.patchValue({
          email: this.unidade.email,
          telefone: this.unidade.telefone,
          nomeFantasia: this.unidade.nomeFantasia,
          razaoSocial: this.unidade.razaoSocial,
          alocacaoUnion: this.unidade.alocacaoUnion,
          inscricaoEstadual: this.unidade.inscricaoEstadual,
          tipo: this.unidade.tipo,
          unidadePai: this.unidade.uuidUnidadePai,
          tabelaPrecoConsulta: this.unidade.tabelaPrecoConsulta,
          valorConsultoria: this.unidade.valorConsultoria,
          idCarsys: this.unidade.idCarsys,
          tokenRg: this.unidade.tokenRg,
          tabelaPrecoTipoLaudo: this.unidade.tabelaPrecoTipoLaudo,
          gerarNota: this.unidade.gerarNota,
        });
        this.cpf.patchValue(this.unidade.cpf);
        this.cnpj.patchValue(this.unidade.cnpj);
        this.formInit();
      });
    }

    this.unidadeService.getListaPermissaoUsuario().then(r => this.listaPermissaoUsuario = r);
    this.unidadeService.getTabelaPrecoTipoLaudo().then(r => this.listaPrecoTipoLaudo = r);

    if(this.id === null){
      this.unidadeService.getTabelaPrecoConsulta().then(r => this.listaPrecoConsulta = r);
    } else {
      this.unidadeService.getTabelaPrecoConsultaUnidadeCliente(this.id).then(r => this.listaPrecoConsulta = r);
    }

    this.unidadeService.getListaTipoUnidade().then(r => this.listaTipoUnidade = r);
    this.unidadeService.getListaUnidadeNomeFantasia().then(r => this.listaUnidades = this.listaUnidades.concat(r));
    this.ciacService.getListaConsultaCreditoSemInsumos().then(r => {
      this.listaConsultaCredito = r.map(item => ({...item, checked: this.listaConsultaCredito.find(i => i.id === item.id)?.checked || false}));
    });
    if (!this.id) this.consultaService.listaConsulta().then(r => this.listaConsultas = r);
    if (!this.id) this.consultaService.listaConsultaCombinada().then(r => this.listaConsultasCombinadas = r);
    if (!this.id) {
      this.unidade.tipoDocumento = "CNPJ";
      this.alterarTipoDocumento(this.unidade.tipoDocumento);
    }



    //desativa o campo idCarsys(data criacao da unidade) para não ser editável e trata
    this.form?.controls?.idCarsys?.disable();
    let date = '01/01/2018';
    try {
      if(!this.id) {
        date = moment().format('DD/MM/YYYY');
      } else {
        const formattedDate = moment(this.unidade.idCarsys, 'MM/DD/YYYY').format('DD/MM/YYYY');
        if(formattedDate != 'Invalid date')
          date = formattedDate;
        else {
          date = '01/01/2018';
        }
    }
    } catch (error) {
        date = '01/01/2018';
    }
    this.unidade.idCarsys = date
    this.form?.controls?.idCarsys?.patchValue(date);
  }

  formInit() {

    this.formEndereco = this.fb.group({
      cep: [this.unidade.endereco.cep],
      cidade: [this.unidade.endereco.cidade],
      estado: [this.unidade.endereco.estado],
      bairro: [this.unidade.endereco.bairro],
      numero: [this.unidade.endereco.numero],
      rua: [this.unidade.endereco.rua],
      complemento: [this.unidade.endereco.complemento],
    });

    this.formUsuario = this.fb.group({
      nome: [this.unidade.usuario.nome],
      email: [this.unidade.usuario.email],
      emailConf: [this.unidade.usuario.email, UtilValidators.equalValidator('email')],
      login: [this.unidade.usuario.login],
      senha: [this.unidade.usuario.senha, [
        Validators.required,
        UtilValidators.senhaComCaracterEspecial,
        UtilValidators.senhaComMaiuscula,
        UtilValidators.senhaComMinuscula,
        UtilValidators.senhaComNumero,
        Validators.minLength(8),
        Validators.maxLength(100)
      ]],
      senhaConf: [this.unidade.usuario.senha, UtilValidators.equalValidator('senha')],
    });

    this.form = this.fb.group({
      // email: [this.unidade.email, [Validators.required, Validators.email]],
      email: [this.unidade.email],
      telefone: [this.unidade.telefone],
      nomeFantasia: [this.unidade.nomeFantasia],
      razaoSocial: [this.unidade.razaoSocial],
      alocacaoUnion: [this.unidade.alocacaoUnion],
      inscricaoEstadual: [this.unidade.inscricaoEstadual],
      tipo: [this.unidade.tipo],
      unidadePai: [this.unidade.uuidUnidadePai],
      tabelaPrecoConsulta: [this.unidade.tabelaPrecoConsulta],
      valorConsultoria: [this.unidade.valorConsultoria],
      idCarsys: [this.unidade.idCarsys],
      tokenRg: [this.unidade.tokenRg],
      tabelaPrecoTipoLaudo: [this.unidade.tabelaPrecoTipoLaudo],
      gerarNota: [this.unidade.gerarNota],
    });
    this.cpf.patchValue(this.unidade.cpf);
    this.cnpj.patchValue(this.unidade.cnpj);
    this.alterarTipoDocumento(this.unidade.tipoDocumento);
    if(this.form.controls.tabelaPrecoConsulta.value == 0) { this.form.controls.tabelaPrecoConsulta.patchValue('') }
    if(this.form.controls.tipo.value == 0) { this.form.controls.tipo.patchValue('') }

    this.formEndereco.controls.cep.valueChanges
      .pipe(
        distinctUntilChanged(),
        debounceTime(400),
        filter(v => v.length == 10)
      )
      .subscribe(v => {
        this.unidade.endereco.cep = v;
        this.enderecoService.pesquisaCEP(this.unidade.endereco).then(r => {
          if (r.erro) {
            this.modalMsgService.openDialog('CEP NÃO ENCONTRADO', 'Verifique o CEP informado, caso ele esteja correto preencha os campos manualmente', 'danger');
          } else {
            let v = this.formEndereco.value;
            this.formEndereco.controls.rua.patchValue(r.rua || v.rua);
            this.formEndereco.controls.bairro.patchValue(r.bairro || v.bairro);
            this.formEndereco.controls.cidade.patchValue(r.cidade || v.cidade);
            this.formEndereco.controls.estado.patchValue(r.estado || v.estado);

            this.enderecoService.presquisaLatLgt(r)
              .then(l => {
                this.unidade.endereco = l;
              }).catch(e => this.unidade.endereco = r);
          }
        }).catch(e => { });
      });

    this.formUsuario.controls.login.valueChanges.pipe(
      distinctUntilChanged(),
      debounceTime(400),
      filter(v => v.length > 3)
    ).subscribe(r => {
      let data = { login: r };
      this.unidadeService.verificaLogin(data).then(r => {
        if(r == true) {
          this.formUsuario.controls.login.clearAsyncValidators();
        } else {
          this.formUsuario.controls.login.setErrors({ msg: 'Login já cadastrado ou inválido' });
        }
      }).catch(e => {
        this.formUsuario.controls.login.setErrors({ msg: 'Login já cadastrado ou inválido' });
      });
    });
  }

  visualizarCamposEditaveis( idUnidade, idURL ){
    if(idUnidade && idURL)
      return idUnidade !== idURL;
    return true;
  }

  alterarTipoDocumento(doc: string) {
    this.unidade.tipoDocumento = doc;
    if (doc == 'CNPJ') {
      this.form.removeControl('cpf');
      this.form.addControl('cnpj', this.cnpj);
      this.form.addControl('razaoSocial', this.razaoSocial);
    } else {
      this.form.addControl('cpf', this.cpf);
      this.form.removeControl('cnpj');
      this.form.removeControl('razaoSocial');
    }
  }

  addImage(event) {
    let reader = new FileReader();

    if (event.target.files && event.target.files.length) {
      const [file] = event.target.files;

      if (file.type.search('image') == -1) {
        this.modalMsgService.openDialog('Formato inválido', 'Selecione um arquivo do tipo imagem (.png/.jpeg)', 'danger');
        this.removeImage();
        return;
      }
      reader.readAsDataURL(file);
      reader.onload = () => this.image = reader.result;
    }
  }

  removeImage() {
    this.image = null;
    this.imageInputFile.nativeElement.value = '';
  }

  setColor(c) {
    if(this.id) {
      let idUnidadeCliente = this.id;
      let idUnidadeLogado = this.login.id;
      if(idUnidadeLogado != idUnidadeCliente) {
        this.unidade.cor = c;
      }else if(idUnidadeLogado == idUnidadeCliente) {
        this.unidade.cor = c;
        this.themeService.setTheme(c);
      }
    }else {
      this.unidade.cor = c;
    }
  }

  consultarCNPJ(event) {

    if(this.id != null) return;

    if(this.form.controls.cnpj.valid){
      this.unidadeService.getDadosCnpjRg(event.target.value).then(r => {
        if(r['codRetorno'] != "0") {
          this.modalMsgService.openDialog('Não foi possível validar o CNPJ informado', r['msgErro'], 'danger');
        } else if(r['empresa']['situacao_cadastral'] != "ATIVA") {
          this.modalMsgService.openDialog('Não foi possível validar o CNPJ informado', "CNPJ não está ativo", 'danger');
        } else {
          let v = this.form.value;
          this.form.controls.razaoSocial.patchValue(r['empresa']['razao_social'].trim() || v.razaoSocial);
          this.form.controls.nomeFantasia.patchValue(r['empresa']['razao_social'].trim() || v.nomeFantasia);

          v = this.formEndereco.value;
          let cep = r['empresa']['cep'].trim();
          if(cep.length == 8) {
            cep = cep.substring(0,2) + '.' + cep.substring(2,5) + '-' + cep.substring(5,8);
          }
          this.formEndereco.controls.cep.patchValue(cep || v.cep);
          this.formEndereco.controls.numero.patchValue(r['empresa']['numero'].trim() || v.numero);
          this.formEndereco.controls.rua.patchValue(r['empresa']['logradouro'].trim() || v.rua);
          this.formEndereco.controls.bairro.patchValue(r['empresa']['bairro'].trim() || v.bairro);
          this.formEndereco.controls.cidade.patchValue(r['empresa']['municipio'].trim() || v.cidade);
          this.formEndereco.controls.estado.patchValue(r['empresa']['uf'].trim() || v.estado);
        }
      }).catch(e => {
        this.modalMsgService.openDialog('Não foi possível validar o CNPJ informado', e.error, 'danger');
        this.form.controls.cnpj.setErrors({ msg: 'Campo obrigatório.' });
      });
    } else
        this.form.controls.cnpj.setErrors({ msg: 'Campo obrigatório.' });
  }

  formatJson() {
    this.unidade.logo = this.image || 'https://unionsolutions-assets.s3.amazonaws.com/icons/brand.png';
    let data = {
      logo: this.image || 'https://unionsolutions-assets.s3.amazonaws.com/icons/brand.png',
      unidade: {
        ...this.unidade,
        ...this.form.value,
        listaConsultas: this.listaConsultas.map(c => ({ ...c, permissao: c.checked || false })),
        listaConsultasCredito: this.listaConsultaCredito.map(c => ({ ...c, checked: c.checked || false })),
        listaConsultasCombinadas: this.listaConsultasCombinadas.map(c => ({ ...c, permissao: c.checked || false, idCombinada: c.id || null })),
        documento: this.unidade.tipoDocumento == 'CNPJ' ? this.cnpj.value : this.cpf.value,
        endereco: {
          ...this.unidade.endereco,
          ...this.formEndereco.value,
        },
        usuario: {
          ...this.unidade.usuario, ...this.formUsuario.value,
          listaPermissao: this.listaPermissaoUsuario.map(p => ({ ...p, ativo: p.checked || false })),
        },
      },
    };

    if (this.id) {
      data['listaConsultas'] = this.listaConsultas.map(c => ({ ...c, permissao: c.checked || false }));
      data['listaConsultasCombinadas'] = this.listaConsultasCombinadas.map(c => ({ ...c, permissao: c.checked || false }) );
      data['listaConsultasCredito'] = this.listaConsultaCredito.map(c => ({ ...c, checked: c.checked || false }));
      data['tipoUnidade'] = this.unidade.tipo;
      data.unidade['idUnidadePai'] = this.login.unidade.id;
      delete data.unidade.usuario;

      // delete data['listaConsultas'];
      delete data['listaConsultasCombinadas'];
      // delete data.listaConsultas;
    }

    return data;
  }

  sendForm() {
    //ativa o campo idCarsys(data criacao da unidade) para ser enviado os dados
    this.form?.controls?.idCarsys?.enable();

    //tratar idcarsys
    let formattedDate = moment(this.form?.controls?.idCarsys.value, 'DD/MM/YYYY').format('MM/DD/YYYY');
    this.form?.controls?.idCarsys.patchValue(formattedDate);

    if (this.form.invalid || this.formEndereco.invalid || (this.formUsuario.invalid && this.id == null)) {
      Object.keys(this.form.controls).forEach(c => this.form.get(c).markAsTouched());
      Object.keys(this.formEndereco.controls).forEach(c => this.formEndereco.get(c).markAsTouched());
      Object.keys(this.formUsuario.controls).forEach(c => this.formUsuario.get(c).markAsTouched());
      this.modalMsgService.openDialog('Preencha todos os campos corretamente',
        'Verifique os erros em vermelho e corrija as informações de acordo com o solicitado', 'danger')

      //desativa o campo idCarsys(data criacao da unidade) para não ser editável
      formattedDate = moment(this.form?.controls?.idCarsys.value, 'MM/DD/YYYY').format('DD/MM/YYYY');
      this.form?.controls?.idCarsys.patchValue(formattedDate);
      this.form?.controls?.idCarsys?.disable();
      return;
    }

    if(this.verificarSePai(this.unidade?.uuid, this.form?.value?.unidadePai)) {
      this.modalMsgService.openDialog(
        'Erro ao ' + (this.id ? 'alterar' : 'cadastrar') + ' unidade',
        'A unidade atual e a unidade pai não podem ser as mesmas.',
        'danger');
        return;
      }

    let data = this.formatJson();

    const params = {
      ip: UserConfigsUtils?.getUserConfigsStorage()?.ip || "",
      ...data
    }

    const modalRef = this.modalService.open(ModalJustificativaComponent, { centered: true });
    modalRef.componentInstance.cabecalho = this.id ? 'Alterar unidade' : 'Nova unidade';
    modalRef.result.then(justificativa => {
      if (justificativa) {
        this.unidadeService[this.id ? 'atualizarUnidade' : 'criarUnidade'](params, justificativa)
          .then(r => {
            if( r['status'] ){
              this.modalMsgService.openDialog('Unidade', r['msg'], 'success')
              this.router.navigate(['unidade', 'listar'])
            }else{
              this.modalMsgService.openDialog('Unidade', r['msg'], 'warning')
            }
          }).catch(e => this.modalMsgService.openDialog('Erro ao ' + (this.id ? 'alterar' : 'cadastrar') + ' unidade',
            'Verifique se todos os campos foram preenchidos corretamente', 'danger'));
      } else {
        this.modalMsgService.openDialog('Erro ao ' + (this.id ? 'alterar' : 'cadastrar') + ' unidade',
          'Informe uma Justificativa para concluir a operação', 'danger');
      }
    }).catch(e => this.modalMsgService.openDialog('Erro ao ' + (this.id ? 'alterar' : 'cadastrar') + ' unidade',
      'Informe uma Justificativa para concluir a operação', 'danger'))
      .finally(()=>{
        //trata e desativa o campo idCarsys(data criacao da unidade) para não ser editável
        formattedDate = moment(this.form?.controls?.idCarsys.value, 'MM/DD/YYYY').format('DD/MM/YYYY');
        this.form?.controls?.idCarsys.patchValue(formattedDate);
        this.form?.controls?.idCarsys?.disable();
      });

  }

  verificarSePai(idUnidade:any, idPai:any){

    try {
      if(!idUnidade || !idPai) return false;
      return (idUnidade == idPai) ? true : false;
    } catch (error) {
      return false;
    }
  }

}
